import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "空手道", "KARATE DŌ", "極真", "KYOKUSHIN", "押忍", "OSU",
  "道場", "DOJO", "ELITE CENTER", "武道", "BUDO",
];

const EditorialMarquee = () => {
  return (
    <section
      aria-hidden="true"
      className="border-y border-[rgba(242,235,229,0.1)] py-8 md:py-10 bg-[#050505] relative overflow-hidden"
      data-testid="marquee-section"
    >
      <Marquee speed={38} gradient={false} pauseOnHover={false}>
        {items.map((t, i) => (
          <span
            key={i}
            className={`font-anton text-6xl md:text-8xl mx-8 md:mx-12 uppercase tracking-tight ${
              i % 3 === 1 ? "text-[#D91604]" : "text-[#f2ebe5]"
            } ${["KARATE DŌ", "OSU", "DOJO", "BUDO", "KYOKUSHIN"].includes(t) ? "" : "font-jp"}`}
          >
            {t}
            <span className="inline-block w-3 h-3 rounded-full bg-[#D91604] ml-8 md:ml-12 align-middle" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
